module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_D_2.68d39020.mp3";